// material-ui
import { styled } from '@mui/material/styles';
import ScreeningContent from './ScreeningContent';

// project imports
// import Journey from './Journey';
// import Services from './Services';
// import KeyFeature from './KeyFeature';
// import Subscribe from './Subscribe';
// import Footer from './Footer';

const SecondWrapper = styled('div')(({ theme }) => ({
	paddingTop: 100,
	[theme.breakpoints.down('md')]: {
		paddingTop: 10
	}
}));

const Screening = () => (
	<>
		<ScreeningContent />
		{/* <SecondWrapper>
			<Journey />
		</SecondWrapper>
		<SecondWrapper>
			<Services />
		</SecondWrapper>
		<SecondWrapper>
			<KeyFeature />
		</SecondWrapper>
		<SecondWrapper>
			<Subscribe />
		</SecondWrapper>
		<Footer /> */}
	</>
);

export default Screening;
